import React, { useEffect, useState } from "react";
import DefaultButton from "../../../../components/buttons/defaultButton";
import PageTableHeader from "../../../../components/pageTableHeader/pageTableHeader";
import CommonModal from "../../../../components/modals/commonModel";
import toast from "react-hot-toast";
import ManageSalaryForm from "../../../../components/forms/payrole/manageSalaryForm";
import PayrollTable from "./components/table";
import {
  createSalaryReport,
  getStaffPayrollAttendance,
} from "../../../../../services/workspace/payroll.service";
import DefaultSearchSelectInput from "../../../../components/inputs/defaultSearchSelectInput";
import { useDispatch, useSelector } from "react-redux";
import { _fetchDepartments } from "../../../../../store/actions/configuration";
import DefaultDatePicker from "../../../../components/inputs/defaultDatePicker";
import moment from "moment";
import YearMonthFilter from "../../../../components/filter/yearMonthFilter";
import { useNavigate } from "react-router-dom";
import DefaultAlert from "../../../../components/alert/defaultAlert";

const items = [
  { label: "Home", path: "/" },
  { label: "Payroll", path: "/payroll" },
  { label: "Payroll Attendance", path: "" },
];

function PayrollAttendance() {
  const [sortOrder, setSortOrder] = useState("");
  const navigate = useNavigate();
  const daysBreak = 7;
  const dispatch = useDispatch();
  const [selectedValue, setSelectedValue] = useState("desc");

  // const [selectedOption, setSelectedOption] = useState(""); // Default value as empty string
  // const [isError, setIsError] = useState(false);
  const [search, setSearch] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectDepartment, setSelectDepartment] = useState([]);
  const [totalData, setTotalData] = useState(0);
  const { departments } = useSelector((state) => state.configuration);
  const { limit } = useState(10);
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [start_date, setStartDate] = useState("");
  const [end_date, setEndDate] = useState("");

  const [seletedDate, setSeletedDate] = useState(new Date());

  const handleChangeDate = (date) => {
    // const firstDay = moment(date, "YYYY-MM-DD h:m").startOf("month").format();
    // const lastDay = moment(date, "YYYY-MM-DD h:m").endOf("month").format();
    // setStartDate(firstDay);
    // setEndDate(lastDay);

    setSeletedDate(moment(date).format("yyyy-MM-DD"));
  };

  const fetchData = () => {
    if (selectDepartment && selectDepartment?.value) {
    } else {
      if (departments && !!departments.length) {
        setSelectDepartment(departments[0]);
      }
    }
    if (selectDepartment && selectDepartment.value) {
      setLoading(true);
      getStaffPayrollAttendance({
        date: seletedDate,
        search,
        page: search ? 1 : currentPage,
        limit,
        order_by: "created_at",
        order_type: selectedValue,
        department_id: selectDepartment.value,
      })
        .then((response) => {
          setLoading(false);
          if (response) {
            let newData = [];
            response.map((item) => {
              let obj = {
                id: item?.staff?.id,
                staff: item?.staff,
                total_days: item?.total_days,
                expected_payable_days: item?.expected_payable_days,
                present: item?.present,
                present_day_salary: item?.present_day_salary,
                leave: item?.leave,
                holidays: item?.holidays,
                weekend: item?.weekend,
                absent: item?.absent,
                absent_day_salary: item?.absent_day_salary,
                payable_days: item?.payable_days,
                unpaid_leaves: item?.unpaid_leaves,
                leave_deduction: item?.unpaid_leave_amount,
                total_hours: item?.total_hours,
                net_salary: item?.net_salary,
                calculated_salary: item?.calculated_salary
                  ? item?.calculated_salary
                  : 0,
                adjustments: item?.adjustments,
          
                paid_leave_amount: item?.paid_leave_amount,
                netSalary: item?.adjustments
                  ? parseFloat(item.adjustments) > 0
                    ? parseFloat(item.calculated_salary) +
                      parseFloat(item?.adjustments)
                    : parseFloat(item?.calculated_salary) -
                      Math.abs(parseFloat(item?.adjustments))
                  : item?.calculated_salary,
                is_paid: item?.is_paid,
                forPaid: item?.forPaid ? item?.forPaid : false,
              };
              newData.push(obj);
            });
            setTableData(newData);
            setTotalData(response.length);
          }
        })
        .catch((error) => {
          setLoading(false);
          toast.error("Failed to fetch payroll attendance data!");
          console.error(error);
        });
    }
  };

  const handleUpdateSalary = (id, value) => {
    const indexId = tableData.findIndex((staff) => staff.id === id);
    console.error(" value", value);

    if (indexId === -1) {
      console.error("Staff ID not found");
      return;
    }

    // Parse the value and handle invalid inputs
    const adjustmentValue = parseFloat(value);
    
    if (isNaN(adjustmentValue)) {
      console.error("Invalid adjustment value", value);
      tableData[indexId].netSalary = parseFloat(
        tableData[indexId].calculated_salary
      );
      if (value !== "-") {
        tableData[indexId].adjustments = "";
      } else {
        tableData[indexId].adjustments = "-";
      }
      setTableData([...tableData]);
      return;
    }

    tableData[indexId].adjustments = adjustmentValue;
    

    // Calculating net salary and updating
    if (adjustmentValue > 0) {
      tableData[indexId].netSalary =
        parseFloat(tableData[indexId].calculated_salary) + adjustmentValue;
    } else if (adjustmentValue < 0) {
      tableData[indexId].netSalary =
        parseFloat(tableData[indexId].calculated_salary) -
        Math.abs(adjustmentValue);
    } else {
      tableData[indexId].netSalary = parseFloat(
        tableData[indexId].calculated_salary
      );
    }

    setTableData([...tableData]);
  };

  const handleUpdateForMakeSalary = (id) => {
    const indexId = tableData.findIndex((staff) => staff.id === id);
    tableData[indexId].forPaid = !tableData[indexId].forPaid;
    // Calculating net salary and updating

    setTableData([...tableData]);
  };

  const handleUpdateForAll = () => {
    const forPaid = tableData[0].forPaid ? false : true;
    tableData
      .filter((d) => !d.is_paid)
      .map((item) => {
        item.forPaid = forPaid;
      });
    setTableData([...tableData]);
  };
  const saveSalary = () => {
    setIsSubmitting(true);
    const data = tableData.filter((item) => item.forPaid);

    const payrollUserData = [];

    data.map((item) => {
      payrollUserData.push({
        user_id: item.staff.user_id,
        expected_payable_days: item.expected_payable_days,
        present: item.present,
        leave: item.leave,
        holidays: item.holidays,
        weekend: item.weekend,
        absent: item.absent,
        payable_days: item.payable_days,
        total_hours: item.total_hours,
        calculated_salary: item.calculated_salary,
        adjustment_amount: item.adjustments ? item.adjustments : 0,
        final_amount: item.netSalary,
        status: 0, // 0 Pending, 1 paid, 2 cancle,
      });
    });

    const payrollAttendanceData = {
      users: payrollUserData,
      salary_date: moment().format("YYYY-MM-DD"),
      department_id: selectDepartment.uuid,
    };

    createSalaryReport(payrollAttendanceData)
      .then((response) => {
        toast.success("Salary report created successfully!");
        navigate("/payroll/salary-report");
      })
      .catch((error) => {
        setIsSubmitting(false);

        toast.error(
          "Failed to create Salary report!" + error.response.data?.message
        );
      })
      .finally(() => setIsSubmitting(false));
  };

  // Debounce search functionality for optimized performance
  useEffect(() => {
    const timer = setTimeout(
      () => {
        fetchData();
      },
      search ? 500 : 0
    ); // Adjust debounce time as needed

    return () => clearTimeout(timer);
  }, [
    search,
    currentPage,
    limit,
    selectedValue,
    selectDepartment,
    seletedDate,
  ]);

  useEffect(() => {
    dispatch(_fetchDepartments());
  }, []);

  return (
    <div className="flex flex-col gap-2">
      <PageTableHeader
        breadcrumbs={items}
        isSearch={true}
        onSearchChange={(e) => setSearch(e.target.value)}
        isFilter={false}
      />

      {isModalOpen && (
        <CommonModal
          modalSize="sm"
          headerTitle={selectedId ? "Edit " : "Add "}
          onClose={() => {
            setSelectedId("");
            fetchData();
            setIsModalOpen(false);
          }}
          onSave={() => {}}
          show={isModalOpen}
        >
          <ManageSalaryForm
            isModal={true}
            onClose={() => {
              setSelectedId("");
              fetchData();
              setIsModalOpen(false);
            }}
            id={selectedId ? selectedId : ""}
          />
        </CommonModal>
      )}
      <DefaultAlert
        heading="NOTE:"
        body={`The displayed salary corresponds to the previous month, as the current month's salary has not yet been generated.`}
      />
      <div className=" flex flex-col ">
        <div className="flex flex-row gap-2 p-4 text-theme font-bold items-center  bg-white">
          <div className="flex flex-row   gap-2">
            <div className="flex flex-row items-center bg-white gap-2">
              <div className="flex flex-row items-center bg-white gap-2">
                <span>Department</span>
                <DefaultSearchSelectInput
                  name="department_id"
                  value={selectDepartment}
                  options={departments}
                  onChange={(e) => {
                    setSelectDepartment(e);
                  }}
                  customClass="w-100"
                />
              </div>
              <YearMonthFilter handleChangeDate={handleChangeDate} />
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-2">
          <PayrollTable
            loading={loading}
            sortOrder={sortOrder}
            setSortOrder={setSortOrder}
            daysBreak={daysBreak}
            payrollList={tableData}
            handleUpdateSalary={handleUpdateSalary}
            handleUpdateForMakeSalary={handleUpdateForMakeSalary}
            handleUpdateForAll={handleUpdateForAll}
          />
          {!loading && tableData && !!tableData.length && (
            <div className="flex flex-row gap-2 items-center">
              <DefaultButton
                minWidth
                name="Save"
                variant=""
                loading={isSubmitting}
                onClick={saveSalary}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default PayrollAttendance;
